export const bodyOverflowTransform = (modalVisible) => {
	const body = document.querySelector('body');
	modalVisible ?
		body?.classList?.add('modal-open') : null;
};

export const bodyOverflowRemove = () => {
	const body = document.querySelector('body');
	body?.classList.remove('modal-open');
};